/** Tuna event names and payloads for the home dashboard (`home.dash.*`). */

import { tunaEvent } from "@app/tuna";

/** Minimal org shape for analytics payloads (matches store `Organization`). */
export type HomeDashOrg = { id: string; name: string };

/** Stable `{ orgId, orgName }` fields used across `home.dash.*` payloads. */
export function homeDashOrgPayload(org: HomeDashOrg) {
  return { orgId: org.id, orgName: org.name };
}

export const HOME_DASH_EVENTS = {
  CONTAINER_EFFICIENCY_POPOVER_OPEN:
    "home.dash.container_efficiency.popover_open",
  CONTAINER_EFFICIENCY_RECOMMENDATIONS_CLICK:
    "home.dash.container_efficiency.recommendations_click",
  CONTAINER_EFFICIENCY_EMPTY_STATE_CTA:
    "home.dash.container_efficiency.empty_state_cta",

  LAST_DEPLOY_EMPTY_DEPLOY_CTA: "home.dash.last_deploy.empty_deploy_cta",
  LAST_DEPLOY_CONNECT_SOURCE_CTA: "home.dash.last_deploy.connect_source_cta",
  LAST_DEPLOY_APP_LINK_CLICK: "home.dash.last_deploy.app_link_click",
  LAST_DEPLOY_SOURCE_LINK_CLICK: "home.dash.last_deploy.source_link_click",

  COMPLIANCE_CARD_OPEN: "home.dash.compliance.card_open",
  COMPLIANCE_BADGE_PREVIEW_OPEN: "home.dash.compliance.badge_preview_open",
  COMPLIANCE_BADGE_DOWNLOAD: "home.dash.compliance.badge_download",
  COMPLIANCE_DEDICATED_STACK_CTA: "home.dash.compliance.dedicated_stack_cta",
  COMPLIANCE_MODAL_CTA: "home.dash.compliance.modal_cta",

  OVERVIEW_DEDICATED_STACKS_CLICK: "home.dash.overview.dedicated_stacks_click",
  OVERVIEW_ENVIRONMENTS_CLICK: "home.dash.overview.environments_click",
  OVERVIEW_APPS_CLICK: "home.dash.overview.apps_click",
  OVERVIEW_DATABASES_CLICK: "home.dash.overview.databases_click",

  RECENTLY_VIEWED_RESOURCE_CLICK: "home.dash.recently_viewed.resource_click",

  ACTIVITY_FEED_VIEW_ALL_CLICK: "home.dash.activity_feed.view_all_click",
} as const;

/**
 * Fire a home-dashboard analytics event with JSON-serialized payload (same pattern as
 * scale recommendations / legacy Tuna callers).
 */
export function homeDashEvent(
  eventName: (typeof HOME_DASH_EVENTS)[keyof typeof HOME_DASH_EVENTS],
  payload: Record<string, unknown>,
): void {
  tunaEvent(eventName, JSON.stringify(payload));
}

export type ContainerEfficiencyVariant = "app" | "database";

export type ComplianceModalCtaAction =
  | "trust_center"
  | "view_controls"
  | "view_docs"
  | "view_controls_locked";
